
<div class="history-container">

  <!-- LOADING -->
  <div *ngIf="loading" class="empty-state">

    <div class="loading-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <p class="empty-subtitle">
      Cargando historial...
    </p>

  </div>

  <!-- ERROR -->
  <div *ngIf="error && !loading" class="empty-state">

    <p class="empty-title">
      No se pudo cargar el historial
    </p>

    <p class="empty-subtitle">
      Ha ocurrido un error al consultar los estudios previos
    </p>

    <button
      class="btn-retry"
      (click)="loadHistory()">

      Reintentar

    </button>

  </div>

  <!-- CONTENIDO -->
  <div
    *ngIf="!loading && !error"
    class="history-scroll-shell">

    <div class="history-list">

      <!-- ESTUDIO ACTUAL -->
      <ng-container *ngIf="actualBookStudies.length">

        <div class="section-title">
          Estudios actuales
        </div>

        <div
          *ngFor="let study of actualBookStudies"
          class="history-card current-study">

          <div class="card-date">
            {{ formatDate(study.studyDate) }}
          </div>

          <div class="card-description">
            {{ study.description || 'Estudio sin descripción' }}
          </div>

          <div class="card-actions">

            <button class="action-btn action-images" (click)="changeTab('book')">

              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="currentColor" stroke-width="1.5"/>
                  <circle cx="16" cy="8" r="2" stroke="currentColor" stroke-width="1.5"/>
                  <path d="M2 12.5001L3.75159 10.9675C4.66286 10.1702 6.03628 10.2159 6.89249 11.0721L11.1822 15.3618C11.8694 16.0491 12.9512 16.1428 13.7464 15.5839L14.0446 15.3744C15.1888 14.5702 16.7369 14.6634 17.7765 15.599L21 18.5001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <span>Imágenes</span>

            </button>

            <button class="action-btn action-report" (click)="openAdvancedVisor(study.studyUID != null ? study.studyUID : '')">

              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 9C2 6.17157 2 4.75736 2.87868 3.87868C3.75736 3 5.17157 3 8 3H16C18.8284 3 20.2426 3 21.1213 3.87868C22 4.75736 22 6.17157 22 9V10C22 12.8284 22 14.2426 21.1213 15.1213C20.2426 16 18.8284 16 16 16H8C5.17157 16 3.75736 16 2.87868 15.1213C2 14.2426 2 12.8284 2 10V9Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M12 19V16.5M12 19L18 21M12 19L6 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>

              <span>Visor Médico</span>

            </button>

          </div>

        </div>

      </ng-container>

      <!-- HISTÓRICO -->
      <ng-container *ngIf="historicStudiesList.length">

        <div class="section-title">
          Estudios previos
        </div>

        <div
          *ngFor="let study of historicStudiesList"
          class="history-card">

          <div class="card-date">
            {{ formatDate(study.studyDate) }}
          </div>

          <div class="card-description">
            {{ study.studyDescription || 'Estudio sin descripción' }}
          </div>

          <div class="card-actions">

            <!--<button class="action-btn action-images" (click)="openBookFromHistoric(study.studyUID != null ? study.studyUID : '', study.studyToken != null ? study.studyToken : '')">

              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="currentColor" stroke-width="1.5"/>
                <circle cx="16" cy="8" r="2" stroke="currentColor" stroke-width="1.5"/>
                <path d="M2 12.5001L3.75159 10.9675C4.66286 10.1702 6.03628 10.2159 6.89249 11.0721L11.1822 15.3618C11.8694 16.0491 12.9512 16.1428 13.7464 15.5839L14.0446 15.3744C15.1888 14.5702 16.7369 14.6634 17.7765 15.599L21 18.5001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>

              <span>Imágenes</span>

            </button>-->

            <button class="action-btn action-report" (click)="openAdvancedVisorFromHistoric(study.studyUID != null ? study.studyUID : '', study.studyToken != null ? study.studyToken : '')">

              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 9C2 6.17157 2 4.75736 2.87868 3.87868C3.75736 3 5.17157 3 8 3H16C18.8284 3 20.2426 3 21.1213 3.87868C22 4.75736 22 6.17157 22 9V10C22 12.8284 22 14.2426 21.1213 15.1213C20.2426 16 18.8284 16 16 16H8C5.17157 16 3.75736 16 2.87868 15.1213C2 14.2426 2 12.8284 2 10V9Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M12 19V16.5M12 19L18 21M12 19L6 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>

              <span>Visor Médico</span>

            </button>

          </div>

        </div>

      </ng-container>

      <!-- SIN HISTÓRICO -->
      <div
        *ngIf="!actualBookStudies.length && !historicStudiesList.length"
        class="empty-state">

        <p class="empty-title">
          Sin estudios previos
        </p>

        <p class="empty-subtitle">
          No se encontraron otros estudios radiológicos para este paciente
        </p>

      </div>

    </div>

  </div>

</div>